import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useViewport } from '@starflow/app/store';
import { useDebounceFn } from 'ahooks';
import { updateUnitData } from '@starflow/app/helpers/flow';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { resizeInnerId } from '../../../constants';
import { domRectToObject } from '../../../utils';
import './index.scss';

const DragInner = forwardRef(({ width, height, left, top, element, generator, getDragWrapperInfo }, ref) => {
  const inner = useRef(null);
  const disXY = useRef({ x: 0, y: 0 });
  const scale = useViewport().scale;
  useImperativeHandle(ref, () => ({
    // 用于处理因为选框的挤压，内部元素自动往里移动
    refreshLocation: ({ width: ww, height: wh, left, top, right: wr, bottom: wb }) => {
      const { right: ir, width: iw, bottom: ib, height: ih } = inner.current.getBoundingClientRect();
      if (wr <= ir) {
        inner.current.style.left = ww - iw + 'px';
      }
      if (wb <= ib) {
        inner.current.style.top = wh - ih + 'px';
      }
      setOffsetToOutpaintImg();
    },
    getRectInfo: () => {
      return inner.current.getBoundingClientRect();
    },
    getRectOffset: () => {
      return { left: inner.current.offsetLeft, top: inner.current.offsetTop };
    },
    getRef: () => {
      return inner.current;
    },
  }));

  const { run: setOffsetToOutpaintImg } = useDebounceFn(
    () => {
      const wrapper = getDragWrapperInfo();
      const innerEl = domRectToObject(inner.current.getBoundingClientRect());

      const warpperObj = {
        ...wrapper,
        width: wrapper.width / scale,
        height: wrapper.height / scale,
      };
      const innerObj = {
        ...innerEl,
        width: innerEl.width / scale,
        height: innerEl.height / scale,
      };
      updateUnitData(generator.id, {
        outpaintRect: {
          wrapper: warpperObj,
          inner: innerObj,
          relativeXY: {
            left: (innerEl.left - wrapper.left) / scale,
            right: (wrapper.left + wrapper.width - innerEl.left - innerEl.width) / scale,
            top: (innerEl.top - wrapper.top) / scale,
            bottom: (wrapper.top + wrapper.height - innerEl.top - innerEl.height) / scale,
          },
        },
      });
    },
    {
      wait: 200,
    },
  );
  const onMouseDown = (e) => {
    // const { width, height } = dragElement.current.getBoundingClientRect();
    // const x = e.clientX;
    // const y = e.clientY;
    // document.onmousemove = (e) => {
    //   const left = e.clientX - x;
    //   console.log('[[[[===>>left', left);
    //   const top = e.clientY - y;
    //   const relativeW = width - e.target.offsetWidth;
    //   const relativeH = height - e.target.offsetHeight;
    //   inner.current.style.left = left < 0 ? 0 : left > relativeW ? relativeW : left + 'px';
    //   inner.current.style.top = top < 0 ? 0 : top > relativeH ? relativeH : top + 'px';
    // };
    // document.onmouseup = (e) => {
    //   document.onmouseup = null;
    //   document.onmousemove = null;
    // };
    //鼠标事件对象
    var oEvent = e;
    disXY.current.x = oEvent.clientX - inner.current.offsetLeft;
    disXY.current.y = oEvent.clientY - inner.current.offsetTop;
    const { width, height } = getDragWrapperInfo();
    document.onmousemove = function (ev) {
      //鼠标事件对象
      var oEvent = ev;
      var l = oEvent.clientX - disXY.current.x;
      var t = oEvent.clientY - disXY.current.y;
      const relativeW = width - inner.current.offsetWidth;
      const relativeH = height - inner.current.offsetHeight;
      const ll = l < 0 ? 0 : l > relativeW ? relativeW : l;
      const tt = t < 0 ? 0 : t > relativeH ? relativeH : t;
      inner.current.style.left = ll + 'px';
      inner.current.style.top = tt + 'px';
      setOffsetToOutpaintImg();
      /**如果父盒子设置有marginTop和marginLeft则需要将其设置为0*/
      inner.current.style.marginLeft = 0;
      inner.current.style.marginTop = 0;
    };
    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
    };

    //阻止默认事件
    return false;
  };

  return (
    <div
      ref={inner}
      id={resizeInnerId}
      onMouseDown={(e) => onMouseDown(e)}
      className="bg-slate-600 absolute pointer-events-auto"
      style={{
        width,
        height,
        left,
        top,
        background: `url('${convert2CompressedUrl(element.url, 400)}') center center /cover`,
      }}
    ></div>
  );
});

export default DragInner;
